// filepath: c:\Users\GianDroxz\Desktop\starboyrecords\starboy\src\firebaseConfig.js
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_Q15bMrI6rLIJ2rclV5mPmdJT-I-e72Q",
  authDomain: "starboyrecords-4995c.firebaseapp.com",
  projectId: "starboyrecords-4995c",
  storageBucket: "starboyrecords-4995c.firebasestorage.app",
  messagingSenderId: "475887322185",
  appId: "1:475887322185:web:fe901107d612722afa2b98",
  measurementId: "G-C0T6PF3WHD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore - Usa la base de datos nombrada 'starboy'
export const db = getFirestore(app);

// Initialize Auth con persistencia local
export const auth = getAuth(app);

// Configurar persistencia para asegurar que la sesión se mantenga
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('✅ Persistencia de Auth configurada correctamente - localStorage');
  })
  .catch((error) => {
    console.error('❌ Error al configurar persistencia:', error);
  });

// Initialize Storage - Bucket: gs://starboyrecords-4995c.firebasestorage.app
// Ubicación: europe-west8 (Milán, Italia)
export const storage = getStorage(app);

// Initialize Analytics only in production
let analytics = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Analytics no disponible:', error.message);
  }
}
export { analytics };

export default app;
